import React from 'react';

export const CustomSelect = ({ itemList, name, value, onChangeItem, label, disabled }) => {

    let options = itemList.map((item) => (
      (item instanceof Object)
        ?
        <option key={item.id} value={item.id}>
          {item.nombre ? item.nombre : item.descripcion}
        </option>
        :
        <option key={item} value={item}>
          {item}
        </option>
    ));
  
    options.unshift(
      <option key={"-1" + name} value="" disabled>
        -- Seleccione--
      </option>
    );
  
    return (
      <div className="form-group">
        <label className="input-label">{label}</label>
        <select
          name={name}
          value={value}
          className="form-control input-box"
          style={{ width: "100%" }}
          disabled={disabled}
          onChange={(e) => onChangeItem(e.target.value)}
        >
          {options}
        </select>
      </div>
    );
  
  }